module.exports = __webpack_public_path__ + "static/media/evercellCarousel4.c8e59336.png";